import { useQuery } from '@tanstack/react-query'

import config from '@config'

import {
  SportCompetitorScheduleAPIResponse,
  UseSportEntitySchedule,
} from './types'

const {
  sports: {
    baseUrlV2: sportsBaseUrlV2,
    sportEntityScheduleCompetitorUrlTemplateV2,
  },
} = config

const fetchSportCompetitorScheduleData = async ({
  typeOfSport,
  entityId,
}: UseSportEntitySchedule) => {
  const requestUrl = `${sportsBaseUrlV2}${sportEntityScheduleCompetitorUrlTemplateV2
    .replace('{SPORT}', typeOfSport)
    .replace('{API_VERSION}', 'v0')
    .replace('{COMPETITOR_ID}', entityId)}`

  const response = await fetch(requestUrl)

  if (!response.ok) {
    throw new Error('Error fetching League Upcoming Games.')
  }

  return response.json() as Promise<SportCompetitorScheduleAPIResponse>
}

const useSportCompetitorSchedule = ({
  entityId,
  typeOfSport,
}: UseSportEntitySchedule) =>
  useQuery({
    queryKey: ['sportCompetitorSchedule', typeOfSport, entityId],
    queryFn: () =>
      fetchSportCompetitorScheduleData({
        typeOfSport,
        entityId,
      }),
  })

export default useSportCompetitorSchedule
